module.exports = __webpack_public_path__ + "assets/user.433b1b47.svg";